// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 카드 */
.ui-card {
  background: var(--card);
  border: 1px solid var(--bd);
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .04);
}

.ui-card--active {
  outline: 2px solid #60a5fa;
}

.ui-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ui-card-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-700);
}

/* 배지 */
.ui-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

/* key-value 라인 */
.ui-kv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 6px;
}

.ui-kv-k {
  color: var(--text-500);
}

.ui-kv-v {
  color: var(--text-700);
  font-weight: 600;
}

/* 스켈레톤 */
.ui-skeleton {
  width: 100%;
  height: 180px;
  border-radius: 8px;
  background:
    linear-gradient(90deg, #f1f5f9 25%, #e5e7eb 37%, #f1f5f9 63%);
  background-size: 400% 100%;
  animation: sk 1.2s ease-in-out infinite;
  border: 1px dashed var(--bd);
}

@keyframes sk {
  0% {
    background-position: 100% 50%
  }

  100% {
    background-position: 0 50%
  }
}

/* 그리드 유틸 */
.ui-grid {
  display: grid;
  gap: 12px;
}

.ui-grid--3 {
  grid-template-columns: repeat(3, minmax(240px, 1fr));
}

/* 리스트 */
.ui-list {
  margin-top: 10px;
}

.ui-list--dense li {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: var(--text-700);
  padding: 4px 0;
}

.ui-list-val {
  color: var(--text-600);
}

/* 텍스트 유틸 */
.ui-text--danger {
  color: var(--danger);
  font-weight: 700;
}

.ui-text--link {
  color: var(--primary);
  cursor: default;
}

/* 리본 */
.ui-ribbon {
  width: 100%;
  padding: 10px 14px;
  border-radius: 6px;
  color: #fff;
  font-weight: 700;
}

.ui-ribbon--danger {
  background: var(--danger);
}

.ui-ribbon--warning {
  background: var(--warning);
}

.ui-ribbon--primary {
  background: var(--primary);
}

.ui-ribbon-label {
  margin-right: 6px;
}

.ui-ribbon-message {
  font-weight: 600;
}




/* ---- div 기반 데이터리스트 (표 대체) ---- */
.ui-dlist {
  border: 1px solid var(--bd);
  /* border-radius:8px; */
  overflow: hidden;
  background: var(--bg-white);
  width: 100%;
}

.ui-dlist__grid {
  display: grid;
  /* ❌ (삭제) 고정 그리드: grid-template-columns: 140px 1fr 160px 200px; */
  gap: 0;
}

.ui-dlist__head {
  background: #f3f4f6;
  border-bottom: 1px solid var(--bd);
}

.ui-dlist__cell {
  padding: 10px 12px;
  font-size: 13px;
  /* color:var(--text-700); */
  /* border-bottom:1px solid #f3f4f6; */
}

.ui-dlist__cell--head {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-600);
}

.ui-dlist__row:last-child .ui-dlist__cell {
  border-bottom: none;
}

.ui-dlist__cell.is-right {
  text-align: right;
}

.ui-dlist__cell.is-center {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/common.css"],"names":[],"mappings":"AAAA,OAAO;AACP;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,OAAO;AACP;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB;iEAC+D;EAC/D,0BAA0B;EAC1B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oDAAoD;AACtD;;AAEA,QAAQ;AACR;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,OAAO;AACP;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;;;;AAKA,mCAAmC;AACnC;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* 카드 */\r\n.ui-card {\r\n  background: var(--card);\r\n  border: 1px solid var(--bd);\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, .04);\r\n}\r\n\r\n.ui-card--active {\r\n  outline: 2px solid #60a5fa;\r\n}\r\n\r\n.ui-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ui-card-title {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-700);\r\n}\r\n\r\n/* 배지 */\r\n.ui-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n}\r\n\r\n/* key-value 라인 */\r\n.ui-kv {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-size: 12px;\r\n  margin-top: 6px;\r\n}\r\n\r\n.ui-kv-k {\r\n  color: var(--text-500);\r\n}\r\n\r\n.ui-kv-v {\r\n  color: var(--text-700);\r\n  font-weight: 600;\r\n}\r\n\r\n/* 스켈레톤 */\r\n.ui-skeleton {\r\n  width: 100%;\r\n  height: 180px;\r\n  border-radius: 8px;\r\n  background:\r\n    linear-gradient(90deg, #f1f5f9 25%, #e5e7eb 37%, #f1f5f9 63%);\r\n  background-size: 400% 100%;\r\n  animation: sk 1.2s ease-in-out infinite;\r\n  border: 1px dashed var(--bd);\r\n}\r\n\r\n@keyframes sk {\r\n  0% {\r\n    background-position: 100% 50%\r\n  }\r\n\r\n  100% {\r\n    background-position: 0 50%\r\n  }\r\n}\r\n\r\n/* 그리드 유틸 */\r\n.ui-grid {\r\n  display: grid;\r\n  gap: 12px;\r\n}\r\n\r\n.ui-grid--3 {\r\n  grid-template-columns: repeat(3, minmax(240px, 1fr));\r\n}\r\n\r\n/* 리스트 */\r\n.ui-list {\r\n  margin-top: 10px;\r\n}\r\n\r\n.ui-list--dense li {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 13px;\r\n  color: var(--text-700);\r\n  padding: 4px 0;\r\n}\r\n\r\n.ui-list-val {\r\n  color: var(--text-600);\r\n}\r\n\r\n/* 텍스트 유틸 */\r\n.ui-text--danger {\r\n  color: var(--danger);\r\n  font-weight: 700;\r\n}\r\n\r\n.ui-text--link {\r\n  color: var(--primary);\r\n  cursor: default;\r\n}\r\n\r\n/* 리본 */\r\n.ui-ribbon {\r\n  width: 100%;\r\n  padding: 10px 14px;\r\n  border-radius: 6px;\r\n  color: #fff;\r\n  font-weight: 700;\r\n}\r\n\r\n.ui-ribbon--danger {\r\n  background: var(--danger);\r\n}\r\n\r\n.ui-ribbon--warning {\r\n  background: var(--warning);\r\n}\r\n\r\n.ui-ribbon--primary {\r\n  background: var(--primary);\r\n}\r\n\r\n.ui-ribbon-label {\r\n  margin-right: 6px;\r\n}\r\n\r\n.ui-ribbon-message {\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n\r\n\r\n/* ---- div 기반 데이터리스트 (표 대체) ---- */\r\n.ui-dlist {\r\n  border: 1px solid var(--bd);\r\n  /* border-radius:8px; */\r\n  overflow: hidden;\r\n  background: var(--bg-white);\r\n  width: 100%;\r\n}\r\n\r\n.ui-dlist__grid {\r\n  display: grid;\r\n  /* ❌ (삭제) 고정 그리드: grid-template-columns: 140px 1fr 160px 200px; */\r\n  gap: 0;\r\n}\r\n\r\n.ui-dlist__head {\r\n  background: #f3f4f6;\r\n  border-bottom: 1px solid var(--bd);\r\n}\r\n\r\n.ui-dlist__cell {\r\n  padding: 10px 12px;\r\n  font-size: 13px;\r\n  /* color:var(--text-700); */\r\n  /* border-bottom:1px solid #f3f4f6; */\r\n}\r\n\r\n.ui-dlist__cell--head {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: var(--text-600);\r\n}\r\n\r\n.ui-dlist__row:last-child .ui-dlist__cell {\r\n  border-bottom: none;\r\n}\r\n\r\n.ui-dlist__cell.is-right {\r\n  text-align: right;\r\n}\r\n\r\n.ui-dlist__cell.is-center {\r\n  text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
